/**
 * The header `jobs` slot (UX-SPEC §17): the resumable job queue and Economy batch status. Each entry names the job by its
 * document, the local date and time it started and its status (UD-21 jobs list): "The Eleventh p5 · 16 Oct 19:52 · done".
 */
import { JOBS } from '../strings-bench.ts';
import { MenuButton } from '../ui.tsx';
import { openJob, removeJobAction } from './controller.ts';
import { jobMenuLabel } from './jobs-format.ts';
import { jobs, liveJobId } from './state.ts';

export function JobsIndicator() {
	const list = jobs.value;
	if (list.length === 0) return null;
	return (
		<MenuButton
			label={`${JOBS.label} (${list.length})`}
			items={list.flatMap((j) => {
				const label = jobMenuLabel(j);
				return [
					// selecting a job opens it for review or resume; deleting is its own item (spec §13.4)
					{ id: j.id, label, onSelect: () => void openJob(j) },
					// the job this page is running opens its live status and is not removed under its run
					...(j.id === liveJobId.value
						? []
						: [
								{
									id: `${j.id}-remove`,
									label: JOBS.removeJob(label),
									onSelect: () => void removeJobAction(j),
								},
							]),
				];
			})}
		/>
	);
}
